//*** import react lib
import {withGoogleMap, withScriptjs, GoogleMap, Marker, useLoadScript, Polyline, DirectionsRenderer, Polygon, LoadScript, HeatmapLayer } from "@react-google-maps/api";
import * as geometry from 'spherical-geometry-js';
import {useMemo, useEffect, useState, useLayoutEffect, useCallback } from "react";
import "../../Assets/Styles/Map.css";
import imgicon from "../../Assets/Images/icon.JPG";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
export function SatelliteData({ang,lat,lon, fid}) {
    const { isLoaded } = useLoadScript({
        //*** google map API key
        //AIzaSyAiAdkcZ_8Bzj5FVkUKdi9xAfOD8fb6vrc // old key Umesh sir
        //AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU// New Key Umesh Sir
        //AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU" //Milind created new key
        //googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyAiAdkcZ_8Bzj5FVkUKdi9xAfOD8fb6vrc",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU",
    });
    const [activeMarker, setActiveMarker] = useState(null);
    //*** Get robot icon
    const icon1 = {
        //url: "http://localhost:44463/#/src/Assets/Images/icon_new.jpg",
        url: "http://bhuhit.com/#/src/Assets/Images/icon_new.jpg",
        //"https://images.vexels.com/media/users/3/154573/isolated/preview/bd08e000a449288c914d851cb9dae110-hatchback-car-top-view-silhouette-by-vexels.png",
    };
    //*** Get line symbol array
    var lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: 4
    };
   const [plantOperationalArea, setPlantOperationalArea] = useState([
        { lat: 18.6999375, lng: 73.919279 },
        { lat: 18.699386, lng: 73.919362 },
        /*{ lat: 18.699098, lng: 73.919206 },*/
        /* { lat: 18.699063, lng: 73.919419 },*/
        { lat: 18.699375, lng: 73.919279},
        { lat: 18.699243, lng: 73.919315 }
    ]);
    const onEdit = useCallback((e) => {
        const newPath = e.getPath().getArray().map(latlng => ({
            lat: latlng.lat(),
            lng: latlng.lng()
        }));
    }, []);
  return (
    <>
      {hasJWTToken() ? (
        <div className="Map">
            <h3 style={{color:"#000" }}>Real Time Robot Operation Tracking</h3>
            <p></p>
            {!isLoaded ? (
                <h1>Loading...</h1>
            ) : (
                <GoogleMap
                    mapContainerClassName="map-container"
                        zoom={20}
                        draggable={true}
                        center={{
                        /* lat: 18.698715, lng: 73.919295*/
                        /*lat: 18.699359, lng: 73.919299*/
                        lat: 18.699007, lng: 73.919228
                    }}
                   >
                </GoogleMap>
            )}
        </div>
        ) :
        (
          <Route to={{pathname:'#/login' }} />
        )
     }
   </>
    );
};
export default SatelliteData;